import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import CaretLink from 'modules/Common/components/CaretLink';
import StorySummary from 'modules/News/components/StorySummary';

require('./TipsSection.scss');

export default function TipsSection({sectionLabel, tipsItems, additionalTipsLinks = [], plainTitle = false}) {
  if (tipsItems.length > 0) {
    let titleClass = "section-title";

    if (plainTitle === true) {
      titleClass = `${titleClass} ${titleClass}-plain`;
    }
    else {
      titleClass = `${titleClass} ${titleClass}-full`;
    }

    const mainLink = (additionalTipsLinks && additionalTipsLinks.length > 0) ? additionalTipsLinks[0].href : null;
    const title = `${sectionLabel} Tips`;  

    return (
      <section className="sport-section">
        <h3 className={titleClass}>{mainLink ? <Link to={mainLink}>{title}</Link> : title}</h3>      
        <section className="sport-tips">
          { tipsItems.map(item => <StorySummary key={item.article_reference.id} imageType="tipArticle" data={item} metaDataFlags={{category: false, byline: true}}/>) }
        </section>
        <div className="action-links sport-links">
            {additionalTipsLinks.map((link, idx) => {
              const classList = ["section-button"];
              (idx === 0 && additionalTipsLinks.length > 1) 
                ? classList.push("large-primary-blue-button") : classList.push("large-primary-button")
              return <Link className={classList.join(' ')} key={`${link.href}:${link.text}`} to={link.href}>{link.text}</Link>
            })}
          </div>        
      </section>
    );
  }
  else {
    return null;
  }
}

TipsSection.propTypes = {
  plainTitle: PropTypes.bool,
  sectionLabel: PropTypes.string.isRequired,
  sectionLink: PropTypes.string.isRequired,
  tipsItems: PropTypes.array,
  additionalTipsLinks: PropTypes.array
};



// WEBPACK FOOTER //
// ./modules/Common/components/TipsSection.js